<!--页面代码从这里开始拷贝-->
<template>
  <div>
    <table-compnent
      :records="tableData"
      @resetHandler="reset"
      @searchHandler="doSearch"
      @queryByIdHandler="queryById"
      @deleteByIdHandler="deleteById"
      @batchDeleteHandler="batchDelete"
      @addHandler="saveConnectorBasic"
    >
      <template v-slot:search>
        <el-form-item label="连接器名称:">
          <el-input
            v-model="search.name"
            placeholder="请输入连接器名称"
          ></el-input>
        </el-form-item>
      </template>
      <template v-slot:content>
        <el-table-column prop="name" label="连接器名称"></el-table-column>
        <el-table-column prop="domain" label="请求域名"></el-table-column>
        <el-table-column prop="url" label="请求地址"></el-table-column>
        <el-table-column prop="method" label="请求方式"></el-table-column>
        <el-table-column prop="remark" label="备注信息"></el-table-column>
      </template>

      <template v-slot:operation="row">
        <el-button type="text" size="small" @click="setParams(row.record.id)">设置连接器参数</el-button>
      </template> 
    </table-compnent>  
  </div>
</template>

<script>
import TableCompnent from "@/components/table/TablesComponents";
import ConnectorBasicApi from '@/api/ConnectorBasicApi';
import { navTo,queryParam } from "@/utils/NavigatorUtils";
export default {
  name: "ConnectorBasicList",
  props: {
    msg: String,
  },
  components: {
    TableCompnent
  },
  data() {
    return {
      tableData: {},
      search: {
        name: "",
      },
      page:{},
      categoryId:0,
    };
  },
  created(){
    this.categoryId = this.$route.query.categoryId;
  },
  methods: {
    reset() {
      this.search = {};
    },
    doSearch(params) {
      this.page = params;
      this.search.pageSize = this.page.pageSize
      this.search.pageNum = this.page.pageNum,
      this.search.categoryId = this.categoryId,
      ConnectorBasicApi.search(this.search).then((resp)=>{
        if(resp.state=="OK"){
          this.tableData = resp.data
        }
      })
    },
    saveConnectorBasic(){
      navTo(this,"/saveConnectorBasic/?categoryId="+this.categoryId);
    },
    queryById(id){
      ConnectorBasicApi.queryConnectorBasicById(id).then((resp)=>{
        if(resp.state=="OK"){
          resp.data.categoryId = this.categoryId;
          queryParam(this,"saveConnectorBasic",resp.data);
        }
      })
    },
    deleteById(id){
      ConnectorBasicApi.deleteConnectorBasic(id).then((resp)=>{
        if(resp.state=="OK"){
          this.doSearch(this.page)
        }else{
          this.$errorMsg(resp.msg)
        }
      })
    },
    batchDelete(params){
      ConnectorBasicApi.batchDeleteConnectorBasic(params).then((resp)=>{
        if(resp.state=="OK"){
          this.$successMsg(resp.msg)
          this.doSearch(this.page)
        }else{
          this.$errorMsg(resp.msg)
        }
      })
    },
    setParams(id){
        queryParam(this,"connectors",{id:id});
    },
  },
};
</script>
<!--页面代码从这里结束拷贝-->